var _excluded = ["type", "disabled", "label", "checked", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

export default React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      disabled = _ref.disabled,
      label = _ref.label,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      input = _objectWithoutProperties(_ref, _excluded);

  var id = "".concat(input.name, "-").concat(input.value || type);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(type, " ").concat(disabled ? 'disabled' : '', " ").concat(className)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    id: id,
    type: type,
    className: "cb-".concat(type),
    disabled: disabled,
    checked: checked,
    ref: ref
  })), /*#__PURE__*/React.createElement("span", {
    className: "cb-span"
  }), label));
});